module.exports = __webpack_public_path__ + "img/driveimage.1404278c.png";